// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-FlashMessage-FlashMessage-module__banner";
export { _1 as "banner" }
